module.exports = __webpack_public_path__ + "static/media/flag-en.ccd886d3.svg";